import React from 'react';
import { Button, Tooltip } from 'antd';
import { Labor as LaborResponse } from '@/DTOS/Labor/Response/Labor';
import { EditOutlined} from '@ant-design/icons';

export const LaborColumn = (handleEdit: (record: LaborResponse) => void) => [
  
  {
    title: 'Labor Id',
    dataIndex: 'id',
    key: 'id',
    hidden: true,
  },
  {
    title: 'Nume',
    dataIndex: 'name',
    key: 'name',
  },
  {
    title: 'Status',
    dataIndex: 'isActive',
    key: 'isActive',
    width: 200,
    render: (isActive: boolean) => (isActive ? 'Activ' : 'Inactiv'),
  },
  {
    title: 'Actiune',
    dataIndex: '',
    key: 'actions',
    render: (record: LaborResponse) => (
      <Tooltip title='Modifica'>
      <Button onClick={() => handleEdit(record)} icon={<EditOutlined/>}></Button>
      </Tooltip>
    ),
    width: 120,
    fixed: 'right'

  },
];
